import api from "./apiConfig";

export const CREATE_CASO = async (data) => {
	try {
		const response = await api.post("/taxMatter", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_CASOS_BY_ENTERPRISE = async (id) => {
	try {
		const response = await api.get(`/taxMatterByClientId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_CASOS_BY_ID = async (id) => {
	try {
		const response = await api.get(`/taxMatter/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_CASO = async (id, data) => {
	try {
		const response = await api.put(`/taxMatter/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const DELETE_CASO = async (id) => {
	try {
		const response = await api.delete(`/taxMatter/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};